import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  TGetDevicersCross,
  TGetCitySegmentsCross,
  TGetCityStreetsCross,
  TGetCityAnalyticsCross,
  TGetCityCross,
} from 'response/CrossResponse';

type TCross = {
  isFetching: boolean;
  analytics_loader: boolean;
  error: string;
  cross_devices: TGetDevicersCross;
  cross_city_segments: TGetCitySegmentsCross;
  cross_city_streets: TGetCityStreetsCross;
  cross_city_cross: TGetCityCross;
  cross_city_analytics: TGetCityAnalyticsCross;
};

const initialState: TCross = {
  isFetching: false,
  analytics_loader: false,
  error: '',
  cross_devices: {
    devices: {},
  },
  cross_city_segments: {
    citySegments: {},
  },
  cross_city_streets: {
    cityStreets: {},
  },
  cross_city_cross: {
    cityCross: {},
  },
  cross_city_analytics: {
    cityAnalytics: {
      analytics_kts: 0,
      analytics_dtp: null,
      analytics_economy: null,
      analytics_effect: null,
      analytics_density: {},
      analytics_speed: {},
      analytics_jam_hour: {},
      analytics_jam_daily: {},
      analytics_jam_count: null,
      analytics_ps_hour: {},
      analytics_ps_daily: {},
      analytics_kts_hour: {},
      analytics_kts_daily: {},
    },
  },
};

export const crossSlice = createSlice({
  name: 'cross',
  initialState,
  reducers: {
    // cross start
    crossFetching(state) {
      state.isFetching = true;
    },
    // cross succes
    crossSuccesGetDevices(state, action: PayloadAction<TGetDevicersCross>) {
      state.isFetching = false;
      state.error = '';
      state.cross_devices = action.payload;
    },
    crossSuccesGetCitySegments(state, action: PayloadAction<TGetCitySegmentsCross>) {
      state.isFetching = false;
      state.error = '';
      state.cross_city_segments = action.payload;
    },
    crossSuccesGetCityStreets(state, action: PayloadAction<TGetCityStreetsCross>) {
      state.isFetching = false;
      state.error = '';
      state.cross_city_streets = action.payload;
    },
    crossSuccesGetCityCross(state, action: PayloadAction<TGetCityCross>) {
      state.isFetching = false;
      state.error = '';
      state.cross_city_cross = action.payload;
    },
    crossSuccesGetCityAnalytics(state, action: PayloadAction<TGetCityAnalyticsCross>) {
      state.isFetching = false;
      state.error = '';
      state.cross_city_analytics = action.payload;
    },
    crossSuccesAnalyticsLoader(state, action: PayloadAction<boolean>) {
      state.isFetching = false;
      state.error = '';
      state.analytics_loader = action.payload;
    },
    // cross error
    crossError(state, action: PayloadAction<string>) {
      state.isFetching = false;
      state.analytics_loader = false;
      state.error = action.payload;
    },
    // cross reset
    crossReset(state) {
      state.cross_city_analytics = initialState.cross_city_analytics;
    },
  },
});

export default crossSlice.reducer;
